import { render, staticRenderFns } from "./SendBtn.vue?vue&type=template&id=0c87b3f6&scoped=true"
import script from "./SendBtn.vue?vue&type=script&lang=js"
export * from "./SendBtn.vue?vue&type=script&lang=js"
import style0 from "./SendBtn.vue?vue&type=style&index=0&id=0c87b3f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87b3f6",
  null
  
)

export default component.exports